<template>
  <section v-if="maintenance" class="d-block small-1">
    <div class="topbar topbar-dark bg-info px-5 text-center">
      <div class="align-items-center">
        <div class="d-none d-md-block text-nowrap text-white">
          <strong class="fs-bold">
            <i class="fa fa-wrench" aria-hidden="true"></i>
            {{ $t('_MaintenanceMessage.maintenance') }}
          </strong>

          {{ maintenance.message }}

          <span v-if="maintenance.end_datetime" class="ms-1">
            <i class="fas fa-clock"></i>
            {{ maintenance_fromnow }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  computed: {
    maintenance_fromnow() {
      if (this.maintenance && this.maintenance.end_datetime) return moment(this.maintenance.end_datetime).fromNow();
      return null;
    },
    ...mapState({
      maintenance: state => state.maintenance,
    }),
  },
};
</script>
